import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ROLES, isStaff } from '../../lib/roles';

interface NavItem {
  to: string;
  label: string;
  /** Si está construido en este scaffold o es un placeholder de fase futura. */
  disponible: boolean;
  soloAdmin?: boolean;
  /** admin o recepción — no profesional ni clienta. */
  soloStaff?: boolean;
}

// Refleja el alcance completo del DAF v2, sección 4 — los módulos no
// construidos aún aparecen deshabilitados a propósito, para que el
// cliente vea el mapa completo del sistema desde el día 1.
const NAV_ITEMS: NavItem[] = [
  { to: '/admin', label: 'Dashboard', disponible: true },
  { to: '/admin/agenda', label: 'Agenda', disponible: true },
  { to: '/admin/clientas', label: 'Clientas', disponible: true },
  { to: '/admin/servicios', label: 'Servicios', disponible: true },
  { to: '/admin/profesionales', label: 'Profesionales', disponible: true, soloStaff: true },
  { to: '/admin/ventas', label: 'Ventas', disponible: true },
  { to: '/admin/cartera', label: 'Cartera de clientas', disponible: true, soloStaff: true },
  { to: '/admin/productos', label: 'Productos', disponible: true },
  { to: '/admin/inventario', label: 'Inventario', disponible: true, soloStaff: true },
  { to: '/admin/proveedores', label: 'Proveedores', disponible: true, soloAdmin: true },
  { to: '/admin/compras', label: 'Compras', disponible: true, soloAdmin: true },
  { to: '/admin/gastos', label: 'Gastos', disponible: true, soloAdmin: true },
  { to: '/admin/caja', label: 'Caja', disponible: true },
  { to: '/admin/comisiones', label: 'Comisiones', disponible: true, soloAdmin: true },
  { to: '/admin/pagos-empleados', label: 'Pagos a empleados', disponible: true, soloAdmin: true },
  { to: '/admin/reportes', label: 'Reportes', disponible: true, soloAdmin: true },
  { to: '/admin/usuarios', label: 'Usuarios', disponible: true, soloAdmin: true },
  { to: '/admin/auditoria', label: 'Auditoría', disponible: true, soloAdmin: true },
];

export function Sidebar() {
  const { perfil } = useAuth();

  const items = NAV_ITEMS.filter(
    (item) => (!item.soloAdmin || perfil?.rol === ROLES.ADMIN) && (!item.soloStaff || isStaff(perfil?.rol)),
  );

  return (
    <aside className="flex h-screen w-60 flex-col border-r border-onyx/10 bg-cream">
      <div className="flex items-center gap-2 px-5 py-6">
        <span className="font-display text-lg tracking-wide text-gold-deep">MC</span>
        <span className="font-display text-sm leading-tight text-onyx">
          María Castro
          <br />
          Nails Spa
        </span>
      </div>

      <nav className="flex-1 space-y-1 overflow-y-auto px-3">
        {items.map((item) =>
          item.disponible ? (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/admin'}
              className={({ isActive }) =>
                `block rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? 'bg-gold/15 text-gold-deep' : 'text-onyx/70 hover:bg-onyx/5'
                }`
              }
            >
              {item.label}
            </NavLink>
          ) : (
            <div
              key={item.to}
              title="Módulo planificado — ver DAF v2, fases de desarrollo"
              className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-onyx/35"
            >
              {item.label}
              <span className="badge bg-onyx/5 text-onyx/40">próx.</span>
            </div>
          ),
        )}
      </nav>
    </aside>
  );
}
